// extracted by mini-css-extract-plugin
export default {"sectionHeader":"CreateTenantModal_sectionHeader__G++SH","toggleContainer":"CreateTenantModal_toggleContainer__YQyl3","toggleLabel":"CreateTenantModal_toggleLabel__MbRRX"};